import { render } from "./JoinChannelDialog.vue?vue&type=template&id=0d73ad06&scoped=true"
import script from "./JoinChannelDialog.vue?vue&type=script&lang=js"
export * from "./JoinChannelDialog.vue?vue&type=script&lang=js"

import "./JoinChannelDialog.vue?vue&type=style&index=0&id=0d73ad06&lang=scss"
import "./JoinChannelDialog.vue?vue&type=style&index=1&id=0d73ad06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d73ad06"]])

export default __exports__